<template>
	<div class="hexin">
		<template v-if="headerShow">
			<div class="hexin_box">
				<indexTitle :title="$t('i18n_73')" @goMore="goMore"></indexTitle>
			</div>
			<div class="hexin_swiper">
				<!-- :list="list" v-if="list.length>0" -->
				<indexHenxiangSwiper ref="indexHenxin" v-if="list.length>0"></indexHenxiangSwiper>
			</div>
		</template>
		<template v-else>
			<div class="hexin_box hexin_boxH5">
				<indexTitle :title="$t('i18n_73')" @goMore="goMore"></indexTitle>
			</div>
			<div class="hexin_swiper">
				<!-- :list="list" v-if="list.length>0" -->
				<indexHenxiangSwiper ref="indexHenxin" v-if="list.length>0"></indexHenxiangSwiper>
			</div>
		</template>

	</div>
</template>

<script>
	import indexTitle from "./indexTitle.vue"
	import indexHenxiangSwiper from "./indexHexinSwiper.vue"
	export default {
		components: {
			indexTitle,
			indexHenxiangSwiper
		},
		data() {
			return {
				list: [
					// {
					// 	img:require("@/assets/content/hexinBanner.png"),
					// 	name:'智能辅助诊疗'
					// },
					// {
					// 	img:require("@/assets/content/hexinBanner.png"),
					// 	name:'智能辅助诊疗'
					// },
					// {
					// 	img:require("@/assets/content/hexinBanner.png"),
					// 	name:'智能辅助诊疗'
					// }
				]
			}
		},
		mounted() {

		},
		methods: {
			goMore() {
				this.$router.push('/innovation')
			},
			setList(e) {
				console.log(e)
				this.list = e;
				this.$nextTick(function() {
					this.$refs.indexHenxin.setList(e)
				})

			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.hexin {
		.hexin_box {
			width: 1200px;
			margin: 0 auto;
		}

		.hexin_swiper {
			// padding-bottom: 160px;
		}
	}

	@media screen and (max-width:1200px) {
		.hexin_boxH5 {
			width: 100% !important;
		}

	}
</style>